import classNames from 'classnames';

export function getPercentageColors(percentage: number, reversePercentageColors = false) {
  return classNames({
    'text-positive!': reversePercentageColors ? percentage < 0 : percentage > 0,
    'text-negative!': reversePercentageColors ? percentage > 0 : percentage < 0,
    'text-neutral!': percentage === 0,
  });
}

/**
 * Returns the current root html font size (1rem) in pixels.
 */
export function getRemSize(): number {
  return parseFloat(getComputedStyle(document.documentElement).fontSize);
}

/**
 * Converts a pixel value to pixels scaled by the current html font size
 * @param px - the pixel value to scale
 * @returns scaled pixel value
 */
export function scalePx(px: number): number {
  // Convert px to rem then back to px based on html font size
  return (px / 16) * getRemSize();
}
